// extracted by mini-css-extract-plugin
export var quillEditor = "_fh-1";
export var variable = "_fh-0";